import dynamic from "next/dynamic";
import ConnectedProductsGridConfig from "./connected-products-grid-config";
import ConnectedProductsGridAdvancedConfig from "./connected-products-grid-advanced-config";
const ConnectedProductsGridComponent = dynamic(()=>import("./connected-products-grid-component"));
export default {
    ConnectedProductsGridComponent,
    ConnectedProductsGridConfig,
    ConnectedProductsGridAdvancedConfig
};
